module.exports = __webpack_public_path__ + "static/media/iconsmind.ec0bfa65.woff";